import { render, staticRenderFns } from "./PatientDashboard.vue?vue&type=template&id=4c74d226&"
import script from "./PatientDashboard.vue?vue&type=script&lang=js&"
export * from "./PatientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PatientDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports